export default __webpack_public_path__ + "static/media/Governance.9fe44f54.svg";